import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { DataColumn } from '../../../../models';
import { UserComponent } from '../../../../shared/user/user.component';
import { MatDialog } from '@angular/material/dialog';
import { MissionDetailsComponent } from './mission-details/mission-details.component';

import { MissionService } from '../../../../services/mission.service';
import { CookieService } from 'ngx-cookie-service';
import { Mission } from '../../../../models/Mission';
import { TableEnCourActionComponent } from './components/table-en-cour-action/table-en-cour-action.component';
import { CandidaturesMissionComponent } from './components/candidatures-mission/candidatures-mission.component';
import { EstablishmentService } from '../../../../services/establishment.service';
import { Site } from '../../../../models/Site';
import { FormBuilder } from '@angular/forms';
import {CandidatStatusOnMission, MissionStatusEnum} from '../../../../shared/utils/enums';
import { debounceTime, skip } from 'rxjs';
import moment from 'moment';
import { removeBlankAttributes } from '../../../../shared/utils/utils.functions';
import { DocuSignDialogComponent } from '../../../../shared/docu-sign-dialog/docu-sign-dialog.component';
import { AuthService } from '../../../../services/auth.service';
import {filterList} from "../../../../shared/utils/data/etablissments-data";
import { ReferenceTitleComponent } from '../reference-title/reference-title.component';
import {SvgIconComponent} from "angular-svg-icon";
import {MatFormField} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";
import {SharedModule} from "../../../../shared/shared.module";
import {NgIf} from "@angular/common";
import {MissionTableActionsComponent} from "./components/mission-table-actions/mission-table-actions.component";
import { log } from 'console';

@Component({
  selector: 'app-agency-in-progress-component',
  templateUrl: './agency-in-progress-component.component.html',
  styleUrl: './agency-in-progress-component.component.scss',
  imports: [
    SvgIconComponent,
    MatFormField,
    MatSelect,
    MatOption,
    SharedModule,
    NgIf
  ],
  standalone: true
})
export class AgencyInProgressComponentComponent implements OnInit {
  // filterList = [
  //   // { label: 'Terminés', value: CandidatStatusOnMission.ARCHIVED },
  //   {
  //     label: 'Confirmés',
  //     value: CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH,
  //   },
  //   { label: 'Acceptés', value: CandidatStatusOnMission.ACCEPTED },
  //   { label: 'Publiés', value: CandidatStatusOnMission.NEUTRAL },
  //   {
  //     label: 'Non publiés',
  //     value: MissionStatusEnum.DRAFT,
  //   },
  // ];
  component: any[] = [UserComponent];
  randomData: any[] = [];
  isLoading: boolean = false;
  // Define the custom columns array
  customColumns: DataColumn[] = [
    {
      header: 'Référence',
      fieldName: 'missionTitle',
      component: ReferenceTitleComponent,
      dataType: 'component',
      col: 'col',
    },
    { header: 'Site', fieldName: 'site', dataType: 'string',  col: 'col', },
    {
      header: 'Service d’affectation',
      fieldName: 'serviceAffectationsName',
      dataType: 'string',
      col: 'col',
    },
    { header: 'Poste', fieldName: 'typePoste', dataType: 'string',col: 'col', },
    {
      header: 'Type de contrat',
      fieldName: 'typecontat',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Dates',
      fieldName: 'duration',
      fieldNameStartDate: 'startdate',
      fieldNameEndDate: 'enddate',
      dataType: 'date',
      col: 'col',
    },
    {
      header: 'Rémunération',
      fieldName: 'compensationproposednet',
      fieldNameCurrency: 'currency',
      dataType: 'currency',
      col: 'col',
    },
    {
      header: 'Candidatures',
      fieldName: 'candidatures',
      dataType: 'component',
      col: 'col',
      component: CandidaturesMissionComponent,
    },

    {
      header: 'Statut',
      fieldName: '',
      component: TableEnCourActionComponent,
      dataType: 'component',
      col: 'col',
      unClickable: true,
    },

    {
      header: 'Actions',
      fieldName: '',
      component: MissionTableActionsComponent,
      dataType: 'component',
      col: 'col',
      unClickable: true,
    },

  ];
  id: number;
  missionList: Mission[] = [];
  offset = 0;
  size = 10;
  totalItems = 0;
  siteList: Site[] = [];

 formFilter = this.fb.group({
  adresseId: undefined,
  endDate: [moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00'],
  compareEndDate: 'SUP',
  missionTitle: [''],
  page: 0,
  size: 10,
  startDate: [''],
  // "Filtrer par date": keep missions whose span contains this date (startdate <= date <= enddate).
  activeOnDate: [<any>null],
  missionStatus: this.fb.control<string[]>([]),
  statusOfCandidatOnMission: this.fb.control<string[]>([])
});
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private api: MissionService,
    private fb: FormBuilder,
    private establishmentService: EstablishmentService,
    private auth: AuthService
  ) {
    this.id = this.route.snapshot.params['establishmentId']??0;
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.fetshMission();
    // Refresh the table whenever an action mutates a mission (cancel, delete, status change…).
    this.api.getRefreshMission().pipe(skip(1)).subscribe(() => this.fetshMission());
    this.getSitesByEstablishment();
    this.formFilter.valueChanges.pipe(debounceTime(700)).subscribe((value) => {
        const missionStatus = this.formFilter.get('missionStatus')?.value || [];
        if (missionStatus.includes('ACCEPTED_AND_SIGNED_BY_BOTH')) {
          missionStatus.push('FRAGMENTED_ALL_ASIGNED')
        }
        const statusOfCandidatOnMission: never[] =  [];
        const statusesToMove = ['ACCEPTED', 'ACCEPTED_AND_SIGNED_BY_BOTH'];
        const updatedStatusOfCandidatOnMission = [
          ...statusOfCandidatOnMission,
          ...missionStatus.filter((status: string) => statusesToMove.includes(status))
        ] as string[];

        this.formFilter.patchValue({
          statusOfCandidatOnMission: updatedStatusOfCandidatOnMission
        }, { emitEvent: false });

        this.fetshMission();
          });

    // #6 Reset to the first page whenever the search term changes (etab en-cours).
    this.formFilter.get('missionTitle')?.valueChanges.subscribe(() => {
      this.formFilter.get('page')?.patchValue(0, { emitEvent: false });
      this.offset = 0;
    });
  }

  getSitesByEstablishment() {
    this.establishmentService
      .getSiteByEstablishmentId(this.id, true)
      .subscribe({
        next: (res) => {
          this.siteList = res;
        },
        error: () => {},
      });
  }
  goTo(): void {
    this.router.navigate([`/agency/mission-by-establishment/${this.id}`]);
  }

prepareRequestBody() {
  const formValue = { ...this.formFilter.value };

  if (formValue.missionStatus && formValue.missionStatus.length > 0) {
    formValue.missionStatus = formValue.missionStatus.filter(status =>
      status !== 'ACCEPTED' && status !== 'ACCEPTED_AND_SIGNED_BY_BOTH'
    );
  } else {
    delete formValue.missionStatus;
  }
  if (formValue.statusOfCandidatOnMission) {
    formValue.statusOfCandidatOnMission = Array.from(new Set(formValue.statusOfCandidatOnMission));
  } else {
    delete formValue.statusOfCandidatOnMission;
  }

  // Normalize the "active on date" filter to a start-of-day datetime the backend can parse.
  if (formValue.activeOnDate) {
    formValue.activeOnDate = moment(formValue.activeOnDate).format('YYYY-MM-DDT00:00:00');
  }

  return removeBlankAttributes(formValue);
}


  fetshMission(): void {
    this.isLoading = true;
    this.api
      .getMissionsByEstablishmentId(
        removeBlankAttributes(this.prepareRequestBody()),
        this.id
      )
      .subscribe({
        next: (res: { content: Mission[]; totalElements: number }) => {
          this.missionList = res.content.map(mission => {
            if (mission.typecontat == 'LIBERAL') {
              mission.typecontat = 'Intérim'
            }
            mission.site = mission?.adresseDto?.name ?? '';
            mission.isUrgent = mission?.isurgent;
            return mission
          });
          this.totalItems = res.totalElements;
          console.log("this.missionList====> ", this.missionList)
        },
        error: () => {},
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  handleRowClick = (row: any) => {
    const dialog = this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: {...row , etbId: this.id},
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.fetshMission();
      }
    });
  };

  pagination(event: any) {
    this.offset = event.pageIndex * this.size;
    this.formFilter.get('page')?.patchValue(event.pageIndex);
    this.fetshMission();
  }

  toggleSelectSite(event: any, site: Site) {
    if (event) {
      this.formFilter.get('adresseId')?.patchValue(site.id);
    } else {
      this.formFilter.get('adresseId')?.patchValue('');
    }
  }

  get addressId(): number {
    return <number>this.formFilter.get('adresseId')?.value;
  }

  protected readonly filterList = filterList;
}
